import React, { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useAPI from '../../hooks/useAPI';
import useUser from '../../hooks/useUser';
import log from '../../helpers/Logger';

export const NotificationBadgeContext = createContext();

export const NotificationBadgeProvider = ({ children }) => {
  const { id: userId, isAuth } = useUser();
  const [count, setCount] = useState(0);
  const { getNotificationCount } = useAPI();

  const fetchData = () =>
    getNotificationCount({ viewed: false })
      .then((res) => setCount(res.count))
      .catch((e) => log.error('Failed to retrieve notifications count', e));

  const refreshCount = () => fetchData();

  useEffect(() => {
    if (!userId || !isAuth) return;
    fetchData();

    const notificationInterval = setInterval(
      fetchData,
      process.env.REACT_APP_LAB_NOTIFICATIONS_COUNT_INTERVAL
    );

    // eslint-disable-next-line consistent-return
    return () => clearInterval(notificationInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, isAuth]);

  return (
    <NotificationBadgeContext.Provider
      value={{
        unreadNotifications: count,
        refresh: refreshCount,
      }}
    >
      {children}
    </NotificationBadgeContext.Provider>
  );
};

NotificationBadgeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
